module.exports = __webpack_public_path__ + "assets/img/maximzie.c1f1789a.svg";